module.exports = __webpack_public_path__ + "static/media/Poppins-Light.fcc40ae9.ttf";